import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { AccentButton } from '../controls/AccentButton';
import { AccentSpinner } from '../controls/AccentSpinner';
import { AccentUploadButton } from '../controls/AccentUpload';
import { AccentFormCtrlNoViewState} from '../controls/bound/AccentFormCtrl';
import { AccentCheckUnbound } from '../controls/unbound/AccentCheckUnbound';
import { AccentComboUnbound } from '../controls/unbound/AccentComboUnbound';
import { AccentTextUnbound } from '../controls/unbound/AccentTextUnBound';
import { update, updateAsFormData } from '../services/DataService';
import { t, accentUtils, formHelper, showOK, def, from } from '../services/HelperService';
import { AccentDialog } from './AccentDialog';

const SketchPad = React.lazy(() => import('../controls/sketch/SketchPad'));

export const documentTypes = {
    file: "file",
    sketch: "sketch"
}

export class AttachDocumentDlg extends React.Component {

    constructor(props) {
        super(props);

        this.refreshSupplierKey = 1;

        this.type = props.type ?? documentTypes.file; 

        this.uploadCtrl = React.createRef();

        // a seeded sketch (an image to draw over, e.g. a 3D Photo's render) already has content: it can be attached as it is
        this.defaultSketch = props.defaultSketch ?? null;

        this.state = {
            hasSketch: !!(this.defaultSketch?.elements?.length),
            SendToSupplier: props.defaultSendToSupplier ?? (props.parentInfo.Type === "SupplyJob"),
            SendToCustomer: false,
            LineID: this.props.parentInfo.LineID,
            SketchName: this.props.parentInfo.defaultSketchName,
        };


        
        this.onLineChanged = this.onLineChanged.bind(this);
        this.attachDocument = this.attachDocument.bind(this);
        this.attachSketch = this.attachSketch.bind(this);
        this.close = this.close.bind(this);
        this.attach = this.attach.bind(this);
        this.onFilesChange = this.onFilesChange.bind(this);
        this.onSendToSupplierChanged = this.onSendToSupplierChanged.bind(this);
        this.onSketchNameChanged = this.onSketchNameChanged.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        if (this.props.getLineQuery) {
            this.props.getLineQuery().then(res => {

                this.setState({ lines: res });

            });
        }


        if (this.props.getSupplierQuery) {
            this.props.getSupplierQuery().then(res => {

                const defaultSupplierID = (res.length == 1) ? res[0].ID : undefined;

                this.refreshSupplierKey++;

                this.setState({ suppliers: res, SupplierID: defaultSupplierID });
            });
        }

    }

    onLineChanged(e) {
        const selectedLine = from(this.state.lines).firstOrDefault(l => l.ID === e);

        const supplierID = selectedLine?.SupplierID;

        const supplier = from(this.state.suppliers).firstOrDefault(s=> s.SupplierID === supplierID);

        this.refreshSupplierKey++;

        this.setState({ LineID: e, SupplierID: supplier?.ID});

    }

    onSketchNameChanged(e) {
        this.setState({ SketchName: e });
    }

    onSendToSupplierChanged(e) {
        this.setState({ SendToSupplier: e.checked });
    }

    onFilesChange() {
        this.forceUpdate();
    }

    async attachDocument(e) {

        var me = this;

        const uploadResult = await me.uploadCtrl.current.getFilesForUpload();

        return await updateAsFormData("AttachDocuments", {
            ParentType: me.props.parentInfo.Type,
            ParentID: me.props.parentInfo.ID,
            Files: uploadResult.files,
            SendToCustomer: me.state.SendToCustomer,
            SendToSupplier: me.state.SendToSupplier,
            LineID: def(me.state.LineID, -99),
            SupplierID: def(me.state.SupplierID, -99)
        });

    }


    async attachSketch(e) {

        const me = this;


        const sketch = await me.uploadCtrl.current.getSketch();


        return await update("AttachSketch", {
            ParentType: me.props.parentInfo.Type,
            ParentID: me.props.parentInfo.ID,
            SketchElements: JSON.stringify(sketch.elements),
            Image: sketch.image,
            Files: JSON.stringify(sketch.files),
            Name: me.state.SketchName,
            SendToCustomer: me.state.SendToCustomer,
            SendToSupplier: me.state.SendToSupplier,
            LineID: def(me.state.LineID, -99),
            SupplierID: def(me.state.SupplierID, -99)
        }, true);
    }


    async attach(e) {



        var me = this;

        const isDocument = me.type === documentTypes.file;

        const res = isDocument ? await me.attachDocument(e) : await me.attachSketch(e);
        
        if (!res.Successfull) {
            showOK("application_strings.grids.documents.attachDlgTitle", res.Message, []).then(function () {
                me.close(res);
            });
        } else {
            showOK("application_strings.grids.documents.attachDlgTitle", "application_strings.grids.documents.uploadSuccess", ["application_strings.application.buttons.ok"], false, null, true, 600).then(function () {
                me.close(res);
            });
        }

        if (e.promise) e.promise();
        
    }

    close(e) {
        this.props.onClose(e);
    }


    render() {
        var me = this;
        var allowFinish = false;

        if (!accentUtils.isNull(this.uploadCtrl.current)) {

            allowFinish = me.type === documentTypes.file
                ? !this.uploadCtrl.current.hasInvalidFile() && this.uploadCtrl.current.fileCount() > 0
                : this.state.hasSketch && !accentUtils.isEmpty(this.state.SketchName);
        }

        const showLine = !accentUtils.isNull(this.props.getLineQuery) && !accentUtils.isEmpty(this.state.lines);
        const showSupplier = showLine;

        const supplierRequired = this.state.SendToSupplier && accentUtils.isNull(this.state.LineID);
        const hasSendDestination = !this.state.SendToSupplier ||
            !accentUtils.isNull(this.state.LineID) ||
            !accentUtils.isEmpty(this.state.SupplierID);
        allowFinish = allowFinish && hasSendDestination;


        return (
            <AccentDialog
                fullscreen={this.type === documentTypes.sketch}
                headerContent={t("application_strings.grids.documents.attachDlgTitle")}
                onClose={this.props.onClose}
                maxWidth={this.type === documentTypes.sketch ? undefined :800}
                actionsContent={[
                    <AccentButton key="2" disabled={!allowFinish} tagName="emailDlgSendBtn" onClick={this.attach}>{t("application_strings.application.buttons.attach")}</AccentButton>
                ]}
            >
                {this.type === documentTypes.sketch && <Row>
                    <Col md={12}>
                        <AccentTextUnbound required label="application_strings.grids.documents.sketchName" defaultValue={this.state.SketchName} onChange={this.onSketchNameChanged} />                        
                    </Col>
                </Row>}
                <Row>
                    <Col md={12}>
                        {this.type === documentTypes.file && <AccentUploadButton ref={this.uploadCtrl} sessionID={this.props.sessionID} onChange={this.onFilesChange} multiple={true} />}
                        {this.type === documentTypes.sketch && <React.Suspense fallback={<div stlye={{ minHeight: "300px" }}><AccentSpinner className="position-absolute top-50 start-50" large /></div>}>
                                <SketchPad methods={this.uploadCtrl} widthAdjustment={30} heightAdjustment={140} defaultValue={this.defaultSketch ?? undefined} notifyDirty={e => this.setState({ hasSketch: true })} />
                        </React.Suspense>}
                    </Col>
                </Row>
                {showLine && <Row>
                    <Col md={12}>
                        <AccentComboUnbound displayField="Description" valueField="ID" onChange={this.onLineChanged} label={ this.props.lineLabel } data={this.state.lines} />
                    </Col>
                </Row>}

                {!this.props.hideSendToCustomer && <Row>
                    <Col md={12}>
                        <AccentCheckUnbound tagName={"sendToCustomer_chk"} label="application_strings.grids.documents.sendToCustomer" defaultValue={this.state.SendToCustomer} onChange={e => this.setState({ SendToCustomer: e.checked })} />
                    </Col>
                </Row>}
                <Row>
                    <Col md={12}>
                        <AccentCheckUnbound tagName={"sendToSupplier_chk"} label="application_strings.grids.documents.sendToSupplier" defaultValue={this.state.SendToSupplier} onChange={this.onSendToSupplierChanged} />
                    </Col>
                </Row>
                {showSupplier && <Row>
                    <Col md={12}>
                        <AccentComboUnbound key={this.refreshSupplierKey} displayField="Name" valueField="ID" required={supplierRequired} disabled={!accentUtils.isNull(this.state.LineID) } defaultValue={ this.state.SupplierID} onChange={e => this.setState({ SupplierID: e })} label="application_strings.grids.documents.supplier" data={this.state.suppliers} />
                    </Col>
                </Row>}
            </AccentDialog>
        );

    }
}

AttachDocumentDlg.defaultProps = {
    hideSendToCustomer: false,
    defaultSendToSupplier: false
};
